import React from 'react';
import { EXTRA_SMALL_SCREEN, screenSize, SMALL_SCREEN } from '../../global/ScreenSizeHelper';
import { FirstTimeCheckerDesktop } from './FirstTimeCheckerDesktop';
import { FirstTimeCheckerMobile } from './FirstTimeCheckerMobile';
import Transition from './../../transition';

export const FirstTimeChecker = () => {
    const isMobile = screenSize === SMALL_SCREEN || screenSize === EXTRA_SMALL_SCREEN;
    return (
        isMobile ? <FirstTimeCheckerMobile /> :
            <FirstTimeCheckerDesktop />
    )
}

export default Transition(FirstTimeChecker)
